import React, { useEffect } from 'react';
import { reportProps } from './StopLossAggregateTable';
import {
  CardComponent,
  NoDataVisual,
  ReportTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Grid } from '@mui/material';
import { numberToCurrencyFormatter } from '../core-utils/helper-utils/helper';

const NetworkLeakageImpact: React.FC<reportProps> = ({ data }) => {
  useEffect(() => {}, []);

  const getDataForInNetworkTable = () => {
    const InNetworkTableData: any[] = [];
    data?.inNetworkSummary?.paginatedResults?.forEach((item: any) => {
      const row = [];
      row.push(item.providerName);
      row.push(item.providerType);
      row.push(item.claims);
      row.push(numberToCurrencyFormatter(item.totalCharge, true, 0));
      row.push(numberToCurrencyFormatter(item.memberPaid, true, 0));
      row.push(numberToCurrencyFormatter(item.planPaid, true, 0));
      InNetworkTableData.push(row);
    });
    return InNetworkTableData;
  };

  const getDataForOutNetworkTable = () => {
    const OutNetworkTableData: any[] = [];
    data?.outNetworkSummary?.paginatedResults?.forEach((item: any) => {
      const row = [];
      row.push(item.providerName);
      row.push(item.providerType);
      row.push(item.claims);
      row.push(numberToCurrencyFormatter(item.totalCharge, true, 0));
      row.push(numberToCurrencyFormatter(item.memberPaid, true, 0));
      row.push(numberToCurrencyFormatter(item.planPaid, true, 0));
      OutNetworkTableData.push(row);
    });
    return OutNetworkTableData;
  };

  const cellStyles1 = {
    color: `${patientAccessTheme.palette.text.highemphasis} !important`,
    padding: '5px 10px !important',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '19.8px',
    borderRight: '1px solid white',
    borderBottom: '4px solid white !important',
    backgroundColor: patientAccessTheme.palette.grey[300],
  };

  const headerStyles1 = {
    color: `${patientAccessTheme.palette.status.white} !important`,
    padding: '5px 10px !important',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    borderRight: '1px solid white',
    borderBottom: '4px solid white !important',
    backgroundColor: patientAccessTheme.palette.grey[700],
  };

  const reportTablecolumns: any[] = [
    {
      name: 'NAME',
      align: 'left',
      width: '150px',
    },
    {
      name: 'TYPE',
      align: 'left',
      width: '70px',
    },
    {
      name: 'CLAIMS',
      align: 'left',
      width: '40px',
    },
    {
      name: 'TOTAL PAID',
      align: 'left',
      width: '100px',
    },
    {
      name: 'MEMBER PAID',
      align: 'left',
      width: '100px',
    },
    {
      name: 'PLAN PAID',
      align: 'left',
      width: '100px',
    },
  ];

  return (
    <Grid
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
      }}
    >
      <Grid
        style={{
          gap: '10px',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        {getDataForInNetworkTable()?.length === 0 ? (
          <CardComponent
            title={'Top 5 In-Network Providers'}
            width="920px"
            height="auto"
            body={
              <NoDataVisual
                content="No Data For Table"
                width="920px"
                height="180px"
              />
            }
          />
        ) : (
          <ReportTable
            columns={reportTablecolumns}
            data={getDataForInNetworkTable()}
            cellStyles={cellStyles1}
            headerStyles={headerStyles1}
            title={'Top 5 In-Network Providers'}
            titleStyles={{
              color: '#8293D9',
              fontSize: '16px',
              fontWeight: 600,
              lineHeight: '22.8px',
              textAlign: 'left',
              paddingLeft: '5px',
            }}
            tableStyles={{
              width: '100%',
              margin: '5px',
            }}
            width={'100%'}
          />
        )}
        {getDataForOutNetworkTable()?.length === 0 ? (
          <CardComponent
            title={'Top 5 Out-of-Network Providers'}
            width="920px"
            height="auto"
            body={
              <NoDataVisual
                content="No Data For Table"
                width="920px"
                height="180px"
              />
            }
          />
        ) : (
          <ReportTable
            columns={reportTablecolumns}
            data={getDataForOutNetworkTable()}
            cellStyles={cellStyles1}
            headerStyles={headerStyles1}
            title={'Top 5 Out-of-Network Providers'}
            titleStyles={{
              color:
                patientAccessTheme.palette.riskStratificationCard?.row2Color,
              fontSize: '16px',
              fontWeight: 600,
              lineHeight: '22.8px',
              textAlign: 'left',
              paddingLeft: '5px',
            }}
            tableStyles={{
              width: '100%',
              margin: '5px',
            }}
            width={'100%'}
          />
        )}
      </Grid>
    </Grid>
  );
};
export default NetworkLeakageImpact;
